
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/keywash",
      function () {
        return require("private-next-pages/keywash.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/keywash"])
      });
    }
  